/**
 * מצב תצוגה (demo): מפעילים עם `npm run demo`.
 * מאפשר לראות את כל המסכים הממותגים בלי Firebase ובלי שרת, עם נתוני דוגמה.
 *
 * הגנות:
 * - פעיל רק כש-Vite רץ ב-mode "demo". `npm run build` רץ ב-production ולכן הדגל false,
 *   והקוד של מצב התצוגה נמחק מהבנייה.
 * - vite.config.ts מסרב לבנות (build) ב-mode demo.
 * - כל המסכים מציגים פס "מצב תצוגה — נתוני דוגמה".
 */
export const IS_DEMO: boolean = import.meta.env.MODE === 'demo';

export const DEMO_CREDENTIALS = {
  email: 'demo@sa-security.co.il',
  password: 'demo1234',
} as const;
